;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import CarouselProvider from 'components/ui/CarouselProvider';

import { blockRootProps } from 'utils';

import FlipDeck from './FlipDeck';

const BlockFlipDeck = ({
    __typename,
    anchorId,
    slides,
    flushTop,
    flushBottom,
    ...descriptionProps
}) => {
    return (
        <div {...blockRootProps(anchorId, __typename)}>
            <CarouselProvider slides={slides}>
                <FlipDeck
                    flushTop={flushTop}
                    flushBottom={flushBottom}
                    {...descriptionProps}
                />
            </CarouselProvider>
        </div>
    );
};

BlockFlipDeck.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    slides: PropTypes.array,
};

export default BlockFlipDeck;
